export default __webpack_public_path__ + "static/media/element_32.3373fe3d.webp";